import * as React from "react";
import { useState, useEffect } from "react";
import { Box, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useAppContext } from "../../context/AppContext";
import Loader from "./Loader";
import DataTable from "./DataTable";
import DataFilter from "./DataFilter";

const DataTabs = () => {
  const [columns, setColumns] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [loading, setLoading] = React.useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "date_time",
    direction: "asc",
  });

  const scrollPosition = window.scrollY;

  const APP_API_URL = process.env.REACT_APP_API_BASE_URL;
  const { deviceId, date, setDate, selectedValue, setTabValue } =
    useAppContext();

  const fetchData = async (tab, currentPage) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${APP_API_URL}/api/get_data.php?deviceID=${deviceId}&tab=${tab}&date=${date}&page=${
          currentPage + 1
        }, &pageRows=${rowsPerPage}`
      );
      const data = await response.json();
      setColumns(data.columns || []);
      setData(data.data || []);
      setTotalRecords(data.total_records || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      window.scrollTo({ top: scrollPosition });
    }
  };

  useEffect(() => {
    setPage(0);
  }, [deviceId]);

  useEffect(() => {
    if (!deviceId) return;
    fetchData(selectedValue, page);
    const shouldPoll = page <= 0;
    if (shouldPoll) {
      const interval = setInterval(() => {
        fetchData(selectedValue, page);
      }, 4 * 60 * 1000); //min*sec*mSec
      return () => clearInterval(interval);
    }
  }, [selectedValue, page, deviceId, date, rowsPerPage]);

  const handleChange = (event, newValue) => {
    setDate("");
    setTabValue(newValue);
    setPage(0); // Reset page on tab switch
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSubmit = () => {
    setPage(0);
    fetchData(selectedValue, page);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {loading && <Loader size={40} />}
      <DataFilter onRefresh={handleSubmit} />
      <TabContext value={selectedValue}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="data tabs">
            <Tab label="Meter Data" value="1" />
            <Tab label="Tamper Data" value="2" />
          </TabList>
        </Box>

        <TabPanel value="1">
          <DataTable
            columns={columns}
            data={data}
            totalRecords={totalRecords}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sortConfig={sortConfig}
            onSortChange={setSortConfig}
            onFilterChange={(filters) => {
              console.log("Filters:", filters);
            }}
          />
        </TabPanel>

        <TabPanel value="2">
          <DataTable
            columns={columns}
            data={data}
            totalRecords={totalRecords}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sortConfig={sortConfig}
            onSortChange={setSortConfig}
            onFilterChange={(filters) => {
              console.log("Filters:", filters);
            }}
          />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default DataTabs;
